import "bootstrap-icons/font/bootstrap-icons.css";

import { Link } from "react-router-dom";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { handleOpenPdf } from "utils";

import fees3 from "assets/images/fees_table_3.svg";
import DepositImage from "assets/images/hero-images/Banner_Deposit.png";
import BG from "assets/images/hero-images/BG.png";
import { ASSETS_BASE_URL } from "constants";

function Commodity2() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Deposits"
          title={`Commodity Murabahah<br>
              <span className="jumbotron-subtitle-2">
                Current Account-<em>i</em>
              </span>`}
          buttonText="Apply Now"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
          backgroundImage={DepositImage}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Need flexibility and good returns on your Current account? Our
              Commodity Murabahah Current Account-<i>i</i>
              <br></br>is there for you.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Zero</div>
                <div className="column-subheader">Service Fee</div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">RM 0</div>
                <div className="column-subheader">Minimum balance </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Low initial deposit</div>
                <div className="column-subheader">
                  RM1,000 (individual)<br></br>RM3,000 (non-individual)
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah Contract</div>
                <div className="column-subheader">
                  Commodity Murabahah (via Tawarruq arrangement)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">VISA-enabled ATM Card</div>
                <div className="column-subheader-2">
                  Accepted for retail purchase @ 35 million retail outlets
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Services</div>
                <div className="column-subheader-2">
                  Range of services available via Internet Banking{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah standards</div>
                <div className="column-subheader-2">
                  Compliance with alrajhi bank Malaysia Shariah standards{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">ATM access</div>
                <div className="column-subheader-2">
                  Access to ATMs displaying Visa PLUS and/or MEPS signs
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Protected by PIDM</div>
                <div className="column-subheader-2">
                  Up to RM250,000 for each depositor
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={fees3}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <Link to="/e-application-form" className="w-full">
                <LinkButton text="e-Application Form" />
              </Link>
              <LinkButton
                text="Profit Rates"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/deposits/Commodity_Murabahah_Rates-Current.ce13fb5e37dcada4b955.pdf`)}
                />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/deposits/PDS_CommodityMurabahahCurrentAccount-i.a9bcc20cd7898257ed43.pdf`)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect!</h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Commodity2;
